(function () {
  'use strict';

  angular.module('ringbaPortal').component('ivrs', {
    controller: IvrsController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/ivrs/ivrs.view.html'
  });

  function IvrsController(
    $state,
    $stateParams,
    $timeout,
    $uibModal,
    $scope,
    $translate,
    accountsService,
    bsLoadingOverlayService,
    ivrService,
    isMobileDevice,
    toaster,
    utils
  ) {
    'ngInject';

    const vm = this;

    vm.$onInit = onInit;
    vm.activateIvrActions = activateIvrActions;
    vm.duplicateIVR = duplicateIVR;
    vm.confirmDeleteModal = confirmDeleteModal;
    vm.confirmDelete = confirmDelete;
    vm.cancelModal = cancelModal;
    vm.setForceUnlink = setForceUnlink;

    function onInit() {
      vm.isMobileView = isMobileDevice;
      vm.loading = true;
      vm.showSpecificRecordDetails = $stateParams.ivrId;
      vm.createAccess = accountsService.hasAccess('IVR', 'CREATE');
      _setViewDetails(vm.showSpecificRecordDetails);
      _loadTemplates();
      _loadIVRTrees();
    }

    function duplicateIVR(ivrId){
      ivrService.duplicateTree(accountsService.currentAccountId, ivrId).then(function (response) {
        $state.go('dashboard.ivr.edit', { treeId: response.ivrTree.id });
      }).catch(utils.errorHandler);
    }

    function activateIvrActions(ivrId) {
      vm.activeActionIvrId = vm.activeActionIvrId == ivrId ? false : ivrId;
    }

    function confirmDeleteModal(ivrTree) {
      vm.ivrTreeReferences = null;
      vm.ivrForDelete = ivrTree;
      vm.forceUnlink = false;
      _getIvrTreeReferences(ivrTree.id);
      vm.modal = $uibModal.open({
        templateUrl: '/scripts/components/ivrs/delete-ivr.modal.html',
        scope: $scope,
        controllerAs: 'vm'
      });
    }

    function confirmDelete() {
      return ivrService.deleteIvrTree(accountsService.currentAccountId, vm.ivrForDelete.id, vm.forceUnlink).then(
        function () {
          toaster.pop('success', $translate.instant('DELETE_IVR_SUCCESSFUL_MESSAGE'));
          _.remove(vm.ivrTrees, function (ivrTree) {
            return ivrTree.id === vm.ivrForDelete.id;
          });
          cancelModal();
        }).catch(utils.errorHandler);
    }

    function cancelModal() {
      if (vm.modal) {
        vm.modal.close();
        vm.modal = null;
        vm.ivrForDelete = null;
      }
    }

    function setForceUnlink(value) {
      vm.forceUnlink = value;
    }

    function _getIvrTreeReferences(ivrTreeId) {
      vm.checkReferencesText = 'DELETE_IVR_MODAL_CHECK_ASSOCIATION_TEXT';
      bsLoadingOverlayService.start();
      ivrService.getIvrTreeReference(accountsService.currentAccountId, ivrTreeId).then(function (response) {
        // We're using timeout here to show the user the checking ivrTree references text
        $timeout(function () {
          bsLoadingOverlayService.stop();
          vm.ivrTreeReferences = response.data;
        }, 800);
      }).catch(function () {
        vm.checkReferencesText = 'DELETE_IVR_MODAL_CHECK_ASSOCIATION_ERROR_TEXT';
        bsLoadingOverlayService.stop();
      });
    }

    function _loadIVRTrees() {
      ivrService.getTreesUI(accountsService.currentAccountId, true, true).then(function (response) {
        vm.ivrTrees = response.ivrTrees;
        vm.loading = false;
      });
    }

    function _loadTemplates() {
      ivrService.getTemplates(accountsService.currentAccountId).then(function (response) {
        vm.ivrTemplates = response;
      });
    }

    function _setViewDetails(showSpecificRecordDetails) {
      let loadingTranslation = 'IVR_TREES_HEADER_LOADING';
      if (showSpecificRecordDetails) {
        loadingTranslation = 'IVR_TREE_HEADER_LOADING';
      } else {
        $translate('MENU_LEFT_IVRS_VIEW').then(function (translation) {
          vm.widgetTitle = translation;
        });
      }

      $translate(loadingTranslation).then(function (translation) {
        vm.loadingText = translation;
      });
    }
  }
})();
